import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { userTypes } from '../../types/user';

import { getUserData } from '../../user/selectors';
import { saveCurrentUser, storeUserData } from '../../user/actions';
import { openModal, closeModal } from '../../components/modal/actions';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { LOCALE_PRE } from './constants';

export class LanguageUpdateCheck extends Component {
  componentDidMount() {
    this.updateCheck();
  }

  updateCheck = () => {
    const { user } = this.props;

    if (user && user.locale) {
      const locale = localStorage.getItem(LOCALE_PRE);
      const language = locale ? locale.replace(/_.*$/, '') : '';

      if (language !== '' && language !== user.locale) {
        this.updatePrompt(locale, language);
      }
    }
  };

  updatePrompt = (locale, language) => {
    const { openModal } = this.props;
    openModal({
      type: 'alert',
      confirmAction: () => this.confirmAction({ locale, language }),
      cancelAction: this.clear,
      title: new TranslatedCopy({ id: 'languagePicker.change' }).toString(),
      confirmText: new TranslatedCopy({ id: 'global.update' }).toString(),
      cancelText: new TranslatedCopy({ id: 'global.cancel' }).toString(),
      content: new TranslatedCopy({
        id: 'languagePicker.change.copy',
        values: { language: language.toUpperCase() }
      }).toString()
    });
  };

  confirmAction = data => {
    const { user, storeUserData, saveCurrentUser } = this.props;

    if (user && user.id && user.country) {
      storeUserData({ ...user, country: user.country, ...data });
      saveCurrentUser({ id: user.id, locale: data?.locale });
    }
    this.clear();
  };

  clear = () => {
    const { closeModal } = this.props;
    localStorage.setItem(LOCALE_PRE, '');
    closeModal();
  };

  render() {
    const { children } = this.props;
    return <>{children}</>;
  }
}

LanguageUpdateCheck.propTypes = {
  children: PropTypes.any,
  user: userTypes,
  saveCurrentUser: PropTypes.func.isRequired,
  storeUserData: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

LanguageUpdateCheck.defaultProps = {
  children: null,
  user: null
};

export default connect(
  state => ({
    user: getUserData(state)
  }),
  {
    saveCurrentUser,
    storeUserData,
    openModal,
    closeModal
  }
)(LanguageUpdateCheck);
